











































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { SubscriptionPackageItem } from "@/types/subscriptionPackage";
import { HttpService } from "@/services/api/httpService";
import axios, { AxiosError } from "axios";
import { ClientClaim } from "@/types/client";

@Component
export default class DashboardClientClaim extends Vue {
  claimId: string = "";
  httpService = new HttpService<ClientClaim>();
  responseArray = new Array<ClientClaim>();
  showModal: boolean = false;
  clientId: any = "";
  removeData = new ClientClaim();
  async getList() {
    let httpService = new HttpService<Array<ClientClaim>>();
    const response = await httpService.getList(
      `clients/${this.clientId}/claims`
    );
    this.responseArray = response.data;
    this.$emit("finishedLoading", true);
  }

  @Watch("$route", { immediate: true }) onRouteChanged() {
    this.clientId = this.$route.params.id;
    this.getList();
  }

  edit(claim: ClientClaim) {
    this.$router.push({
      name: "clientClaimEdit",
      params: {
        id: this.clientId,
        claimId: claim.id
      }
    });
  }

  confirmRemove(data: ClientClaim) {
    this.showModal = true;
    this.removeData = data;
  }
  async remove(data: ClientClaim) {
    const response = await this.httpService.deleteItem(
      `clients/${data.clientId}/claims`,
      data.id
    );

    this.responseArray = this.responseArray.filter(
      (item: ClientClaim) => item.clientId != data.clientId,
      this.$notification.success(`${data.type} successfully removed!`)
    );

    this.showModal = false;
    this.getList();
  }
}
